import React, { useState, useEffect, useRef } from "react";
import {
  getAllLicense,
  addNewLicense,
  updateLicense,
  getLicenseById,
  deleteLicense,
} from "../services/userServices";
import homeImage from "../assets/image/main_image.png";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import "../assets/css/Homepage.css";
import { useNavigate } from "react-router-dom";
// import TimePicker from 'react-time-picker';
// import 'react-time-picker/dist/TimePicker.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const LANGUAGES = [
  { label: "English", value: "en-US" },
  { label: "Korean", value: "ko-KR" },
  { label: "Japanese", value: "ja-JP" },
  { label: "Chinese", value: "zh" },
  { label: "Russian", value: "ru" },
  // { label: "Vietnamese", value: "vi" },
];
const LANGUAGESTRANSLATE = [
  { label: "English", value: "en-US" },
  { label: "Korean", value: "ko-KR" },
  { label: "Japanese", value: "ja-JP" },
  { label: "Chinese", value: "zh" },
  { label: "Russian", value: "ru" },
  { label: "Vietnamese", value: "vi" },
  { label: "Uzbek", value: "uz" },
  { label: "Mongolian", value: "mn" },
];
const ENGINES = [
  { label: "Systran", value: "normalSystran" },
  { label: "Systran (Hyundai)", value: "huyndaiSystran" },
  { label: "Google", value: "gg" },
  { label: "DeepL", value: "dpl" },
  { label: "Papago", value: "ppg" },
];

const LicensePage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showHide, setShowHide] = useState(false);
  const navigate = useNavigate();
  const [searchKey, setSearchKey] = useState("");
  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const tabbarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tabbarRef.current && !tabbarRef.current.contains(event.target)) {
        setShowHide(false);
      }
    }

    if (showHide) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showHide]);
  const [form, setForm] = useState({
    key: "",
    languages: [],
    languagesTranslate:[],
    engines: [],
    expireDay: null,
    expiredAt: null,
    createdAt: null,
    status: "Unactive",
  });

  useEffect(() => {
    fetchLicenses();
  }, []);

  const fetchLicenses = async () => {
    try {
      const response = await getAllLicense();
      setItems(response.respObj);
    } catch (err) {
      setError("Failed to load licenses");
    } finally {
      setLoading(false);
    }
  };

  const handleAddLicense = () => {
    setForm({
      key: "",
      languages: [],
      languagesTranslate:[],
      engines: [],
      expireDay: null,
      expiredAt:null,
      status: "Unactive",
    });
    setShowModal(true);
  };

  const handleEditLicense = async (id) => {
    const response = await getLicenseById(id);
    console.log("response",response)
    setForm({
      id: response.respObj.id,
      key: response.respObj.key,
      languages: response.respObj.languages || [],
      languagesTranslate:response.respObj.languagesTranslate || [],
      engines: response.respObj.engines || [],
      expireDay: response.respObj.expireDay || null,
      expiredAt:response.respObj.expiredAt || null,
      createdAt: response.respObj.createdAt || null,
      status: response.respObj.status || "Unactive",
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setForm({ key: "", languages: [], expireDay: null, status: "Unactive" });
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   let newValue = value;

  //   if (name === "expireDay") {
  //     const num = parseInt(value, 10);

  //     if (value !== "" && (isNaN(num) || num <= 0)) {
  //       newValue = 1;
  //     }
  //     if (value === "") {
  //       newValue = null;
  //     }
  //   }

  //   setForm({ ...form, [name]: newValue });
  // };
  const handleChange = (e) => {
    const { name, value } = e;
    let newValue = value;

    if (name === 'expiredAt') {
      let expiredAtDate;

      if (!value) {
        newValue = null;
      } else if (value instanceof Date) {
        newValue = value;
        expiredAtDate = value;
      } else {
        const parsed = new Date(value);
        newValue = isNaN(parsed) ? null : parsed;
        expiredAtDate = parsed;
      }

      // Tính số ngày giữa expiredAt và ngày hiện tại
      console.log("form",form)
      const createdAt = form.createdAt ? new Date(form.createdAt) : new Date();
      console.log("createdAt", createdAt)
      if (expiredAtDate) {
        expiredAtDate.setHours(
          createdAt.getHours(),
          createdAt.getMinutes(),
          createdAt.getSeconds(),
          createdAt.getMilliseconds()
        );

        const diffMs = expiredAtDate.getTime() - createdAt.getTime();
        const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        newValue = expiredAtDate;
        setForm((form) => ({
          ...form,
          [name]: newValue,
          expireDay: diffDays > 0 ? diffDays : 1,
        }));
        console.log("newValue",newValue)
        console.log("formmm", form)
        return;
      }
    }

    setForm((form) => ({ ...form, [name]: newValue }));
  };

  const handleLanguageChange = (lang) => {
    setForm((prev) => ({
      ...prev,
      languages: prev.languages.includes(lang)
        ? prev.languages.filter((l) => l !== lang)
        : [...prev.languages, lang],
    }));
  };
  const handleLanguageTransChange = (lang) => {
    setForm((prev) => ({
      ...prev,
      languagesTranslate: prev.languagesTranslate?.includes(lang)
        ? prev.languagesTranslate.filter((l) => l !== lang)
        : [...prev.languagesTranslate, lang],
    }));
  };
  const handleEngineChange = (eng) => {
    setForm((prev) => ({
      ...prev,
      engines: prev.engines.includes(eng)
        ? prev.engines.filter((l) => l !== eng)
        : [...prev.engines, eng],
    }));
  };

  const handleSubmit = async () => {
    if (!form.key || form.languages.length === 0 || form.engines.length === 0) {
      Swal.fire({
        title: "Warning!",
        text: "Please enter complete information!",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      if (form.id) {
        const dataToSend = {
          ...form,
          expiredAt: form.expiredAt ? new Date(form.expiredAt).toISOString() : null,
        };
        await updateLicense(dataToSend);
        Swal.fire({
          title: "Success!",
          text: "License updated successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        const dataToSend = {
          ...form,
          expiredAt: form.expiredAt ? new Date(form.expiredAt).toISOString() : null,
        };
        console.log("dataSend", dataToSend)
        await addNewLicense(dataToSend);
        Swal.fire({
          title: "Success!",
          text: "License added successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });
      }

      setShowModal(false);
      fetchLicenses();
    } catch (err) {
      Swal.fire({
        title: "Error!",
        text: `Failed to ${form.id ? "update" : "add"} license!`,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleDeleteLicense = async (id) => {
    Swal.fire({
      title: "Are you sure??",
      text: "This license will be deleted and cannot be restored.!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Delete now!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteLicense(id);
          Swal.fire({
            title: "Deleted!",
            text: "License has been deleted successfully.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchLicenses();
          });
        } catch (error) {
          Swal.fire({
            title: "Error!",
            text: "Unable to delete license. Please try again!",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const openTabbar = () => {
    setShowHide(!showHide);
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
      (
        +c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
      ).toString(16)
    );
  }

  const handleShowDetail = (key) => {
    navigate(`/details-license/${key}`);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const getLabelFromValues = (values, options) => {
    return values
      ?.map((val) => options.find((opt) => opt.value === val)?.label || "")
      .join(" ");
  };

  const filteredItems = items
    .filter((item) => {
      const search = searchKey.toLowerCase();

      const languageLabels = getLabelFromValues(
        item.languages,
        LANGUAGES
      ).toLowerCase();
      const engineLabels = getLabelFromValues(
        item.engines,
        ENGINES
      ).toLowerCase();
      const expireDayText =
        item.expireDay === 9999 ? "permanently" : item.expireDay.toString();
      const statusText = (item.status ?? "Unactive").toLowerCase();
      const createdAtText = new Date(item.createdAt).toLocaleDateString(
        "vi-VN"
      );

      const combinedContent = `
        ${item.key}
        ${languageLabels}
        ${engineLabels}
        ${expireDayText}
        ${statusText}
        ${createdAtText}
      `.toLowerCase();

      return combinedContent.includes(search);
    })
    .sort((a, b) => {
      if (!sortField) return 0;

      let aValue = a[sortField];
      let bValue = b[sortField];

      if (sortField === "createdAt") {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      if (sortField === "status") {
        aValue = (aValue ?? "Unactive") === "Active" ? 1 : 0;
        bValue = (bValue ?? "Unactive") === "Active" ? 1 : 0;
      }

      if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
      if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });

  const SortIcon = ({ active, direction }) => (
    <span
      style={{
        // marginLeft: 4,
        display: "inline-flex",
        flexDirection: "column",
        cursor: "pointer",
        // fontSize: 12,
        // lineHeight: 1,
      }}
    >
      <svg
        width="14px"
        height="14px"
        viewBox="0 0 20 20"
        fill={active && direction === "asc" ? "black" : "#ccc"}
      >
        <path d="M10 5l-5 5h10l-5-5z" />
      </svg>
      <svg
        width="14px"
        height="14px"
        viewBox="0 0 20 20"
        fill={active && direction === "desc" ? "black" : "#ccc"}
      >
        <path d="M10 15l5-5H5l5 5z" />
      </svg>
    </span>
  );

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

  return (
    <>
      <div ref={tabbarRef} className={`tabbar ${showHide ? "open" : ""}`}>
        <ul>
          <li>
            <svg
              style={{ cursor: "pointer" }}
              onClick={openTabbar}
              fill="#000000"
              width="24px"
              height="24px"
              viewBox="0 -2 28 28"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path d="m5.216 11.998c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m5.216 2.608c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m5.216 21.389c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m9.794 0h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
                <path d="m9.794 9.39h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
                <path d="m9.794 18.781h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              </g>
            </svg>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/home")}
            >
              Home
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/manage-license")}
            >
              License
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/manage-logo")}
            >
              Manage logo
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/change-password")}
            >
              Change password
            </div>
          </li>
        </ul>
      </div>
      <div
        style={{
          backgroundImage: `url(${homeImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          minHeight: "300px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          //   alignItems: "center",
          //   justifyContent: "center",
          textAlign: "center",
          color: "black",
          fontSize: "2rem",
          fontWeight: "bold",
          textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
          position: "relative",
        }}
      >
        <div className="top-action">
          <svg
            onClick={openTabbar}
            fill="#000000"
            width="24px"
            height="24px"
            viewBox="0 -2 28 28"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path d="m2.61 0h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              <path d="m2.61 9.39h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              <path d="m2.61 18.781h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
            </g>
          </svg>
          <div
            style={{
              // position: "absolute",
              right: "10px",
              top: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              cursor: "pointer",
            }}
            onClick={logout}
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9 0L3 2V14H1V16H15V14H13V2H11V14H9V0ZM6.75 9C7.16421 9 7.5 8.55229 7.5 8C7.5 7.44772 7.16421 7 6.75 7C6.33579 7 6 7.44772 6 8C6 8.55229 6.33579 9 6.75 9Z"
                  fill="#000000"
                ></path>{" "}
              </g>
            </svg>
            Logout
          </div>
        </div>
        Manage License Config
      </div>

      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="title-license">List License</div>
          <div
            style={{
              display: "flex",
              // justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="">
              <input
                type="text"
                className="form-control input-search"
                placeholder="Search by key..."
                value={searchKey}
                onChange={(e) => setSearchKey(e.target.value)}
              />
            </div>
            <button
              className="btn btn-primary text-white btn-add"
              onClick={handleAddLicense}
            >
              Add new license
            </button>
          </div>
        </div>

        {loading && <p>Loading...</p>}
        {error && <div className="alert alert-danger">{error}</div>}

        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th
                  className="cursor-pointer"
                  onClick={() => handleSort("key")}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>Key</span>

                    <SortIcon
                      active={sortField === "key"}
                      direction={sortOrder}
                    />
                  </div>
                </th>
                <th>Languages</th>
                <th>Languages Translate</th>
                <th style={{ width: "180px" }}>Translation Engines</th>
                <th
                  className="cursor-pointer"
                  // style={{ width: "80px" }}
                  onClick={() => handleSort("expireDay")}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    Expire Day
                    <SortIcon
                      active={sortField === "expireDay"}
                      direction={sortOrder}
                    />
                  </div>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => handleSort("status")}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    Status
                    <SortIcon
                      active={sortField === "status"}
                      direction={sortOrder}
                    />
                  </div>
                </th>
                <th
                  className="cursor-pointer"
                  // style={{ width: "80px" }}
                  onClick={() => handleSort("createdAt")}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    Create At
                    <SortIcon
                      active={sortField === "createdAt"}
                      direction={sortOrder}
                    />
                  </div>
                </th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {!loading && !error && currentItems.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center text-muted">
                    No data
                  </td>
                </tr>
              ) : (
                currentItems.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td
                      // style={{ cursor: "pointer" }}
                      // onClick={() => handleShowDetail(item.key)}
                    >
                      {item.key}
                    </td>
                    <td>
                      {item.languages.map((lang, i) => {
                        const matchedLang = LANGUAGES.find(
                          (l) => l.value === lang
                        );
                        return (
                          <span key={i} className="badge bg-primary me-1">
                            {matchedLang ? matchedLang.label : lang}
                          </span>
                        );
                      })}
                    </td>
                    <td>
                      {item?.languagesTranslate?.map((lang, i) => {
                        const matchedLangTrans = LANGUAGESTRANSLATE.find(
                          (l) => l.value === lang
                        );
                        return (
                          <span key={i} className="badge bg-primary me-1">
                            {matchedLangTrans ? matchedLangTrans.label : lang}
                          </span>
                        );
                      })}
                    </td>
                    <td>
                      {item.engines.map((eng, i) => {
                        const matchedEngine = ENGINES.find(
                          (e) => e.value === eng
                        );
                        return (
                          <span key={i} className="badge bg-secondary me-1">
                            {matchedEngine ? matchedEngine.label : eng}
                          </span>
                        );
                      })}
                    </td>
                    <td>
                      {item.expireDay === 9999
                        ? "Permanently"
                        : `${item.expireDay} days`}{" "}
                    </td>
                    <td>
                      {item.status === "Active"
                        ? item.status
                        : "Not activated yet"}
                    </td>
                    <td>
                      {new Date(item.createdAt).toLocaleDateString("vi-VN")}
                    </td>
                    <td>
                      <div className="d-flex align-items-center justify-content-center">
                        {item.status === "Active" ? (
                          ""
                        ) : (
                          <button
                            className="btn btn-warning btn-sm me-2"
                            onClick={() => handleEditLicense(item.id)}
                          >
                            <svg
                              width="16px"
                              height="16px"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                              <g
                                id="SVGRepo_tracerCarrier"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></g>
                              <g id="SVGRepo_iconCarrier">
                                {" "}
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M21.1213 2.70705C19.9497 1.53548 18.0503 1.53547 16.8787 2.70705L15.1989 4.38685L7.29289 12.2928C7.16473 12.421 7.07382 12.5816 7.02986 12.7574L6.02986 16.7574C5.94466 17.0982 6.04451 17.4587 6.29289 17.707C6.54127 17.9554 6.90176 18.0553 7.24254 17.9701L11.2425 16.9701C11.4184 16.9261 11.5789 16.8352 11.7071 16.707L19.5556 8.85857L21.2929 7.12126C22.4645 5.94969 22.4645 4.05019 21.2929 2.87862L21.1213 2.70705ZM18.2929 4.12126C18.6834 3.73074 19.3166 3.73074 19.7071 4.12126L19.8787 4.29283C20.2692 4.68336 20.2692 5.31653 19.8787 5.70705L18.8622 6.72357L17.3068 5.10738L18.2929 4.12126ZM15.8923 6.52185L17.4477 8.13804L10.4888 15.097L8.37437 15.6256L8.90296 13.5112L15.8923 6.52185ZM4 7.99994C4 7.44766 4.44772 6.99994 5 6.99994H10C10.5523 6.99994 11 6.55223 11 5.99994C11 5.44766 10.5523 4.99994 10 4.99994H5C3.34315 4.99994 2 6.34309 2 7.99994V18.9999C2 20.6568 3.34315 21.9999 5 21.9999H16C17.6569 21.9999 19 20.6568 19 18.9999V13.9999C19 13.4477 18.5523 12.9999 18 12.9999C17.4477 12.9999 17 13.4477 17 13.9999V18.9999C17 19.5522 16.5523 19.9999 16 19.9999H5C4.44772 19.9999 4 19.5522 4 18.9999V7.99994Z"
                                  fill="#ffffff"
                                ></path>{" "}
                              </g>
                            </svg>
                          </button>
                        )}

                        <button
                        style={{ marginRight: '8px' }}
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDeleteLicense(item.id)}
                        >
                          <svg
                            width="16px"
                            height="16px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                d="M10 12V17"
                                stroke="#ffffff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>{" "}
                              <path
                                d="M14 12V17"
                                stroke="#ffffff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>{" "}
                              <path
                                d="M4 7H20"
                                stroke="#ffffff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>{" "}
                              <path
                                d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10"
                                stroke="#ffffff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>{" "}
                              <path
                                d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                                stroke="#ffffff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>{" "}
                            </g>
                          </svg>
                        </button>
                        <button
                          className="btn btn-info btn-sm"
                          onClick={() => handleShowDetail(item.key)}
                        >
                          <svg
                            width="16px"
                            height="16px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              <path
                                d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                                stroke="#ffffff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <circle
                                cx="12"
                                cy="12"
                                r="3"
                                stroke="#ffffff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></circle>
                            </g>
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "32px",
            marginBottom: "40px",
            gap: "8px",
          }}
        >
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            style={{
              padding: "6px 12px",
              border: "1px solid #ccc",
              backgroundColor: currentPage === 1 ? "#eee" : "#fff",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            Prev
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              onClick={() => setCurrentPage(i + 1)}
              style={{
                padding: "6px 12px",
                border: "1px solid #ccc",
                backgroundColor: currentPage === i + 1 ? "#007bff" : "#fff",
                color: currentPage === i + 1 ? "#fff" : "#000",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            style={{
              padding: "6px 12px",
              border: "1px solid #ccc",
              backgroundColor: currentPage === totalPages ? "#eee" : "#fff",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            Next
          </button>
        </div>
      </div>
      {showModal && (
        <div
          className="modal fade show"
          style={{ background: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h6>{form.id ? "Edit License" : "Add New License"}</h6>
                <button
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Key</label>
                  {form.id ? (
                    <input
                      type="text"
                      className="form-control"
                      name="key"
                      value={form.key}
                      disabled
                    />
                  ) : (
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="key"
                        value={form.key}
                        disabled
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() =>
                          setForm((prev) => ({
                            ...prev,
                            key: uuidv4().toUpperCase(),
                          }))
                        }
                      >
                        Generate
                      </button>
                    </div>
                  )}
                </div>


                <div className="mb-3 d-none">
                  <label className="form-label">Created</label>
                  {form.id ? (
                    <input
                      type="text"
                      className="form-control"
                      name="createdAt"
                      value={form.createdAt}
                      disabled
                    />
                  ) : (
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="createdAt"
                        value={form.createdAt}
                        disabled
                      />
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">Languages</label>
                  <div>
                    {LANGUAGES.map(({ label, value }) => (
                      <div key={value} className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={form.languages.includes(value)}
                          onChange={() => handleLanguageChange(value)}
                        />
                        <label className="form-check-label">{label}</label>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Languages Translate</label>
                  <div>
                    {LANGUAGESTRANSLATE.map(({ label, value }) => (
                      <div key={value} className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={form.languagesTranslate?.includes(value)}
                          onChange={() => handleLanguageTransChange(value)}
                        />
                        <label className="form-check-label">{label}</label>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Translation Engines</label>
                  <div>
                    {ENGINES.map(({ label, value }) => (
                      <div key={value} className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={form.engines.includes(value)}
                          onChange={() => handleEngineChange(value)}
                        />
                        <label className="form-check-label">{label}</label>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mb-3" style={{display: "flex", flexDirection : "column"}}>
                  <label className="form-label">Expire Day</label>
                  {/* <input
                    type="number"
                    className="form-control"
                    name="expireDay"
                    value={form.expireDay}
                    min={1}
                    onChange={handleChange}
                  /> */}
                  <DatePicker
                    // selected={form.expireDay ? new Date(form.expireDay) : null}
                    selected={form.expiredAt
                    ? new Date(form.expiredAt)
                    : null}
                    onChange={(date) =>
                      handleChange({ name: 'expiredAt', value: date })
                    }
                    // value={form.expiredAt}
                    className="form-control"
                    showTimeSelect
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Input expired date (dd/mm/yyyy)"
                    isClearable
                  />
                  <span style={{ color: "gray", marginTop:"10px" }}>
                    Leave blank if the license is permanent.
                  </span>
                </div>

                <div className="mb-3">
                  <label className="form-label">Status</label>
                  <input
                    type="text"
                    className="form-control"
                    value="Unactive"
                    disabled
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-success" onClick={handleSubmit}>
                  {form.id ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LicensePage;
